/* eslint-disable import/no-cycle */
import { getMultiWireTestStationXLSX } from './mwts.report.api';

/* eslint-disable import/prefer-default-export */
export async function batchMWTSReports(
	index = 0,
	selected,
	approval,
	searches
) {
	const res = await getMultiWireTestStationXLSX({
		selected,
		approval,
		searches,
		from: index * 10000,
		size: 10000
	});
	return res;
}
